/**
 * Модуль с данными о праздничных и сокращенных днях России
 */

/**
 * Получение списка праздничных и предпраздничных дней для указанного года
 * @param {number} year - Год для получения праздников
 * @returns {Array} Массив праздничных и предпраздничных дней
 */
export const russianHolidaysForYear = (year) => {
    // Стандартные праздничные дни
    const standardHolidays = [
      { date: `${year}-01-01`, name: 'Новогодние каникулы', type: 'holiday' },
      { date: `${year}-01-02`, name: 'Новогодние каникулы', type: 'holiday' },
      { date: `${year}-01-03`, name: 'Новогодние каникулы', type: 'holiday' },
      { date: `${year}-01-04`, name: 'Новогодние каникулы', type: 'holiday' },
      { date: `${year}-01-05`, name: 'Новогодние каникулы', type: 'holiday' },
      { date: `${year}-01-06`, name: 'Новогодние каникулы', type: 'holiday' },
      { date: `${year}-01-07`, name: 'Рождество Христово', type: 'holiday' },
      { date: `${year}-01-08`, name: 'Новогодние каникулы', type: 'holiday' },
      { date: `${year}-02-23`, name: 'День защитника Отечества', type: 'holiday' },
      { date: `${year}-03-08`, name: 'Международный женский день', type: 'holiday' },
      { date: `${year}-05-01`, name: 'Праздник Весны и Труда', type: 'holiday' },
      { date: `${year}-05-09`, name: 'День Победы', type: 'holiday' },
      { date: `${year}-06-12`, name: 'День России', type: 'holiday' },
      { date: `${year}-11-04`, name: 'День народного единства', type: 'holiday' }
    ];
  
    // Предпраздничные (сокращенные) дни
    const shortenedDays = [
      { date: `${year}-02-22`, name: 'Предпраздничный день (23 февраля)', type: 'shortened' },
      { date: `${year}-03-07`, name: 'Предпраздничный день (8 марта)', type: 'shortened' },
      { date: `${year}-04-30`, name: 'Предпраздничный день (1 мая)', type: 'shortened' },
      { date: `${year}-05-08`, name: 'Предпраздничный день (9 мая)', type: 'shortened' },
      { date: `${year}-06-11`, name: 'Предпраздничный день (12 июня)', type: 'shortened' },
      { date: `${year}-11-03`, name: 'Предпраздничный день (4 ноября)', type: 'shortened' },
      { date: `${year}-12-31`, name: 'Предпраздничный день (Новый год)', type: 'shortened' }
    ];
  
    // Добавляем специфические переносы для разных лет
    let transferredHolidays = [];
  
    // 2023 год
    if (year === 2023) {
      transferredHolidays = [
        { date: '2023-02-24', name: 'Перенос выходного с 1 января', type: 'holiday' },
        { date: '2023-05-08', name: 'Перенос выходного с 8 января', type: 'holiday' }
      ];
    } 
    // 2024 год
    else if (year === 2024) {
      transferredHolidays = [
        { date: '2024-04-29', name: 'Перенос выходного с выходного дня', type: 'holiday' },
        { date: '2024-04-30', name: 'Перенос выходного с выходного дня', type: 'holiday' },
        { date: '2024-05-10', name: 'Перенос выходного с выходного дня', type: 'holiday' }
      ];
    }
    // 2025 год
    else if (year === 2025) {
      transferredHolidays = [
        { date: '2025-05-02', name: 'Перенос выходного дня', type: 'holiday' },
        { date: '2025-06-13', name: 'Перенос выходного дня', type: 'holiday' }
      ];
    }
  
    // Объединяем все праздники и выходные дни
    return [...standardHolidays, ...shortenedDays, ...transferredHolidays];
  };
  
  /**
   * Проверяет, является ли дата праздничным днем в России
   * @param {Date} date - Дата для проверки
   * @returns {Object|null} Информация о празднике или null
   */
  export const isRussianHoliday = (date) => {
    const year = date.getFullYear();
    const holidays = russianHolidaysForYear(year);
    
    const dateString = date.toISOString().split('T')[0]; // YYYY-MM-DD
    
    return holidays.find(holiday => holiday.date === dateString) || null;
  };
  
  /**
   * Получение списка всех праздничных дней в России для текущего года
   * @returns {Array} Массив праздничных дней
   */
  export const getCurrentYearHolidays = () => {
    const currentYear = new Date().getFullYear();
    return russianHolidaysForYear(currentYear);
  };
  
  /**
   * Получение ближайшего праздника
   * @param {Date} [fromDate=new Date()] - Дата, от которой искать ближайший праздник
   * @returns {Object|null} Информация о ближайшем празднике
   */
  export const getNextHoliday = (fromDate = new Date()) => {
    const year = fromDate.getFullYear();
    const holidays = russianHolidaysForYear(year);
    
    // Фильтруем только праздничные дни (не сокращенные)
    const onlyHolidays = holidays.filter(holiday => holiday.type === 'holiday');
    
    // Сортируем по дате и находим ближайший будущий праздник
    const fromDateString = fromDate.toISOString().split('T')[0];
    
    const futureHolidays = onlyHolidays.filter(holiday => holiday.date >= fromDateString);
    
    if (futureHolidays.length > 0) {
      return futureHolidays[0];
    }
    
    // Если не нашли в текущем году, ищем в следующем
    const nextYearHolidays = russianHolidaysForYear(year + 1).filter(holiday => holiday.type === 'holiday');
    return nextYearHolidays[0] || null;
  };
  
  export default {
    russianHolidaysForYear,
    isRussianHoliday,
    getCurrentYearHolidays,
    getNextHoliday
  };